import { render, staticRenderFns } from "./add-invite.vue?vue&type=template&id=68b80436&scoped=true&"
import script from "./add-invite.vue?vue&type=script&lang=js&"
export * from "./add-invite.vue?vue&type=script&lang=js&"
import style0 from "./add-invite.vue?vue&type=style&index=0&id=68b80436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b80436",
  null
  
)

export default component.exports